import React from "react"

// TODO: Turn it on inside config-data.js file
const Content = () => {

	return(
    <></>
  );
};

export default Content